import { gql } from '@apollo/client';

export const HASHTAGS_SELECT_ITEM_FRAGMENT_FOR_HASHTAG_SET = gql`
    fragment HashtagSelectItemFragmentForHashtagSet on HashtagSet {
        id
        title
        hashtags
    }
`;
